















import { Vue, Component, Prop } from "vue-property-decorator";
import { FrameStore } from "@/modules/base";
import { BackgroundModule } from "@/modules/BackgroundModule";

@Component
export default class extends Vue {
  @Prop({ required: true })
  frameStore!: FrameStore<typeof BackgroundModule>

  get enableNHK() {
    return process.env.ENABLE_NHK
  }
}
